<script lang="ts">
    import HomeIntro from 'src/components/main/home/components/home-intro/HomeIntro.svelte'
    import VisitCommunity from 'src/components/main/#common/visit-community/VisitCommunity.svelte'
    import MainLayout from '../#common/layout/Layout.svelte'
    import GameCards from 'src/components/main/home/components/game-cards/GameCards.svelte'
    import Audience from 'src/components/main/home/components/audience/Audience.svelte'
    import Advantages from 'src/components/main/home/components/advantages/Advantages.svelte'
    import Blog from 'src/components/main/home/components/blog/Blog.svelte'
    import Audit from 'src/components/main/home/components/audit/Audit.svelte'
    import OurMission from 'src/components/main/home/components/our-mission/OurMission.svelte'
    import Event from 'src/components/main/home/components/event/Event.svelte'
    import Bybit from 'src/components/main/home/components/bybit/Bybit.svelte'
</script>

<svelte:head>
    <title>Realis: Cryptocurrency mobile games on blockchain</title>
    <meta name="description" content="Realis is the world's first platform for launching mobile games for a mass audience with the integration of Blockchain, Defi and NFT components"/>
</svelte:head>

<MainLayout home={true}>
    <svelte:fragment slot="content">
        <!--<Event/>-->
        <HomeIntro/>
        <!--<Bybit/>-->
        <GameCards/>
        <!--<Audit/>-->
        <!--<OurMission/>-->
        <!--<Advantages/>-->
        <Audience/>
        <!--<Blog/>-->
        <!--<VisitCommunity/>-->
    </svelte:fragment>
</MainLayout>
